import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { render } from 'react-dom';
import ReactTags from 'react-tag-autocomplete';
import { matchSorter } from 'match-sorter';
import jsLang from '../lib/jslang';

function suggestionsTransform(query, suggestions) {
    return matchSorter(suggestions, query, { keys: ['name'] });
}

export default class Tags extends Component {
    constructor(props) {
        super(props);

        const {
            suggestions, value,
        } = props;

        this.state = {
            tags: value.map(id => {
                const {
                    name,
                } = suggestions.find(suggestion => suggestion.id === id);

                return {
                    id,
                    name,
                };
            }),
            suggestions: suggestions.map(({
                id, name, is_active: isActive,
            }) => ({
                id,
                name,
                isActive: isActive !== undefined ? isActive : true,
            })),
        };

        this.handleDeletion = this.handleDeletion.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
    }

    handleDeletion(i) {
        const tags = this.state.tags.slice(0);
        tags.splice(i, 1);
        this.setState({
            tags,
        });
    }

    handleAddition(tag) {
        const tags = [...this.state.tags, tag];
        this.setState({
            tags,
        });
    }

    render() {
        const {
            tags,
            suggestions,
        } = this.state;
        const {
            name,
            placeholder,
        } = this.props;
        const selectedTagIds = tags.map(tag => tag.id);

        return (
            <Fragment>
                <ReactTags
                    tagComponent={
                        ({
                            tag, removeButtonText, onDelete,
                        }) => {
                            const { isActive } = suggestions.find(suggestion => suggestion.id === tag.id);

                            return (
                                <button
                                    className={ `label font-size-xs bold m-r-xxs ${isActive ? 'bg-primary' : 'bg-light-grey colour-light'}` }
                                    type="button"
                                    title={ `${removeButtonText}: ${tag.name}` }
                                    onClick={ onDelete }
                                >
                                    { tag.name }
                                </button>
                            );
                        }
                    }
                    placeholderText={ placeholder }
                    tags={ tags }
                    suggestionComponent={
                        ({ item }) => (
                            <span id={ `${name}_${item.id}` } className="flex justify-between items-center">
                                <span>{ item.name }</span>
                                { !item.isActive
                                    ? <span className="label bg-light-grey colour-light font-size-sm bold">{ jsLang.get('admin.inactive') }</span>
                                    : <span /> }
                            </span>
                        )
                    }
                    suggestions={ suggestions.filter(suggestion => !selectedTagIds.includes(suggestion.id)) }
                    suggestionsTransform={ suggestionsTransform }
                    onDelete={ this.handleDeletion }
                    onAddition={ this.handleAddition }
                    minQueryLength={ 0 }
                    maxSuggestionsLength={ suggestions.length }
                />
                <select
                    className="hidden"
                    multiple
                    name={ `${name}[]` }
                    value={ selectedTagIds }
                    aria-disabled
                    aria-hidden
                    onChange={ () => null }
                >
                    { suggestions.map(suggestion => <option key={ suggestion.id } value={ suggestion.id }>{ suggestion.name }</option>) }
                </select>
            </Fragment>
        );
    }
}

Tags.propTypes = {
    name: PropTypes.string.isRequired,
    suggestions: PropTypes.arrayOf(PropTypes.object).isRequired,
    value: PropTypes.arrayOf(PropTypes.number).isRequired,
    placeholder: PropTypes.string.isRequired,
};

document.querySelectorAll('.tags.form__field').forEach(element => {
    const props = Object.assign({}, element.dataset);
    const suggestions = JSON.parse(decodeURIComponent(props.suggestions));
    const value = (JSON.parse(props.value) || []).map(v => parseInt(v, 10));
    const placeholder = decodeURIComponent(props.placeholder);

    render(<Tags { ...props } suggestions={ suggestions } value={ value } placeholder={ placeholder } />, element);
});
